exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.mailHolder[data-v-853b2614] {\n  position: relative;\n  max-height: 100px;\n  overflow: hidden;\n  transition: all 300ms ease-in-out;\n}\n.mailHolder.closed[data-v-853b2614] {\n    max-height: 0;\n}\n.mailHolder .closeIcon[data-v-853b2614] {\n    position: absolute;\n    top: 0.5rem;\n    right: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-853b2614","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/other/noInternetExplorer.vue
// module id = 2383
// module chunks = 0